import React from 'react'

export default function Title({text, style={}}) {
  return (
    <h3 className='text-title mb-6' style={style}>{text}</h3>
  )
}
